import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Stack } from "@mui/material";
import Main from "../components/Layout/Main";
import Footer from "../components/Layout/Footer";
import Content from "../components/Layout/Content";
import Sidebar from "../components/Layout/Sidebar";
import EditorFloatingDrawer from "../components/Layout/EditorFloatingDrawer";
import { GlobalChatProvider } from "../contexts/GlobalChatContext";
import { EditorV2Provider } from "../contexts/EditorV2Context";
import { SMSUnreadProvider } from "../contexts/SMSUnreadContext";
import GlobalChatbot from "../components/GlobalChatbot/GlobalChatbot";

const Dashboard = ({ children }) => {
  const location = useLocation();
  const hideFooter = location.pathname === "/sql/editor" || location.pathname === "/code";

  return (
    <EditorV2Provider>
    <GlobalChatProvider>
    <SMSUnreadProvider>
      <React.Fragment>
        <Stack direction={"row"} width={"100%"} alignItems={"stretch"}>
          <Sidebar />
          <Main>
            <Content>
              {children}
              <Outlet />
            </Content>
            {!hideFooter && <Footer />}
          </Main>
        </Stack>
        <EditorFloatingDrawer />
        <GlobalChatbot />
      </React.Fragment>
    </SMSUnreadProvider>
    </GlobalChatProvider>
    </EditorV2Provider>
  );
};

export default Dashboard;
